import { Stack, SxProps, Typography } from "@mui/material";

import { tagVariants } from "./constants";
import { TAG } from "./types";

interface TagProps {
    sx?: SxProps;
    wrapperSx?: SxProps;
    children?: React.ReactNode;
    tagVariant?: TAG;
}
export function Tag({ sx, wrapperSx, children, tagVariant = TAG.BETA }: TagProps) {
    const variant = tagVariants[tagVariant];

    return (
        <Stack
            direction={"row"}
            alignItems={"center"}
            maxWidth={"fit-content"}
            padding={"0.4rem"}
            borderRadius={2}
            height={"1.6rem"}
            sx={[
                {
                    backgroundColor: variant.backgroundColor,
                },
                ...(Array.isArray(wrapperSx) ? wrapperSx : [wrapperSx]),
            ]}
        >
            <Typography
                variant={"button"}
                color={"#fff"}
                fontSize={"0.8rem"}
                fontWeight={"700"}
                textAlign={"center"}
                lineHeight={"1.1"}
                sx={[...(Array.isArray(sx) ? sx : [sx])]}
            >
                {children || variant.label}
            </Typography>
        </Stack>
    );
}
